import React from 'react';
import AppIcon from './AppIcon';

export default function ReportThemeIcon({ name }) {
    return <AppIcon name={name} className="rel-theme-icon" />;
}
